export default "__VITE_ASSET__j5fS8kG4__"